import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface StatUpIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const StatUpIcon = ({ className, ...props }: StatUpIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 20V12M16 12L19 15M16 12L13 15"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M4 14L12 6L15 9L20 4"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default StatUpIcon;
